import ErrorBoundary from '@nobia/zeus-components/lib/errorBoundary'
import settings from '@nobia/zeus-components/lib/settings'
import styled, { theme } from '@nobia/zeus-components/lib/styled'
import PropTypes from 'prop-types'
import React, { createElement, lazy, Suspense } from 'react'

import { Loader } from '../loader/Loader'
import { Navigation } from '../navigation'
import { SettingsProvider } from '../user-settings/SettingsProvider'

const Help = lazy(() => import('../help/Help'))
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${(p) => p.theme.media.min.lg`
    margin-left: ${p.navigation ? theme('navigation.wrapper.lg.width') : 0};
  `}
`

const Page = ({ children, header, navigation, loading }) => {
  const parsedHeader =
    typeof header === 'function' ? createElement(header) : header
  const parsedChildren =
    typeof children === 'function' ? createElement(children) : children
  return (
    <SettingsProvider>
      <Wrapper>
        {parsedHeader}
        <ContentWrapper navigation={navigation}>
          <Suspense fallback={null}>
            {(settings.brand === 'magnet' || settings.brand === 'marbodal') && (
              <Help />
            )}
          </Suspense>
          <ErrorBoundary name="page">
            {loading ? <Loader /> : parsedChildren}
          </ErrorBoundary>
        </ContentWrapper>
        {navigation && <Navigation />}
      </Wrapper>
    </SettingsProvider>
  )
}

Page.defaultProps = {
  header: <></>,
  navigation: true,
  loading: false,
}

Page.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  navigation: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Page
